import { Play, AlertTriangle, CheckCircle2 } from "lucide-react";
import { AppColorVariant } from "../../theme/AppColorVariant";

export enum MigrationEventStepType {
  Started = "started",
  Interrupted = "interrupted",
  Finished = "finished",
}

export const MigrationEventStepLabels: Record<MigrationEventStepType, string> = {
  [MigrationEventStepType.Started]: "In progress",
  [MigrationEventStepType.Interrupted]: "Interrupted",
  [MigrationEventStepType.Finished]: "Finished",
};

export const MigrationEventStepColors: Record<MigrationEventStepType, AppColorVariant> = {
  [MigrationEventStepType.Started]: "warning",
  [MigrationEventStepType.Interrupted]: "danger",
  [MigrationEventStepType.Finished]: "success",
};

export const MigrationEventStepIcons: Record<MigrationEventStepType, React.ElementType> = {
  [MigrationEventStepType.Started]: Play,
  [MigrationEventStepType.Interrupted]: AlertTriangle,
  [MigrationEventStepType.Finished]: CheckCircle2,
};
